import template from './report_param_dialog.html';

/**
 * @class ReportParamDialogVM
 */
class ReportParamDialogVM
{
	constructor (dialog)
	{
		this.dialog = dialog;

		this.params_fields = ko.observableArray([]);
		this.params_inputs = ko.observable({});

		this.ui_fields = ko.observableArray([]);
		this.default_function_criteria = ko.observable({});
	}

	load ()
	{
		let report_params = this.ui_fields();

		report_params.forEach((f) => {
			if (this.default_function_criteria()?.[f.name]){
				if (f.type == 'json'){
					let val = JSON.stringify(this.default_function_criteria()[f.name]);
					f.default_value = val;
				}
				else if (f.type = 'list'){
					if (f.list_options != ''){
						f.items = f.list_options.split(',');
					}
					f.default_value = this.default_function_criteria()[f.name];
				}else
					f.default_value = this.default_function_criteria()[f.name];
			}
		});

		this.params_fields(report_params);
	}

	async btnSave_click ()
	{
		let message = {
			params: {}
		};
			let params = {};
			for (let [name, input] of Object.entries(this.params_inputs())){
				for (const field of this.ui_fields()){
					if (field.name == name){
						if (field.type == 'json'){
							if (typeof (input()) === "object")
								params[name] = input();
							else
								params[name] = JSON.parse(input());
						}else if (field.type == 'list'){
							if (typeof (input()) === "object")
								params[name] = input().value;
							else
								params[name] = input();
						}else
							params[name] = input();
					}
				}
			}
			message.params = params;

		this.dialog.close(message);
	}

}

/**
 * @class ReportParamDialog
 * @implements {GrapeDialogType}
 * @param {Object} bindings
 * @example
 */
class ReportParamDialog
{
	constructor (bindings)
	{
		this.bindings = bindings;
		/**
		 * @memberof ReportParamDialog
		 * @name viewModel
		 * @type {ReportParamDialogVM}
		 */
		this.viewModel = new ReportParamDialogVM(this);

		this.init();
	}

	/**
	 * Init function
	 * @memberof AutoSchedulerDialog
	 * @alias init
	 */
	async init () 
	{
		this.viewModel.ui_fields(this.bindings.initial_values.ui_fields);
		this.viewModel.default_function_criteria(this.bindings.initial_values.default_function_criteria);
		this.viewModel.load();
	}

	/**
	 * Event handler for close button
	 * @memberof AutoSchedulerDialog
	 * @alias btnclose_click
	 */
	btnClose_click ()
	{
		this.close();
	}
}

export default {
	name: 'ReportParamDialog',
	dialog_class: ReportParamDialog,
	template: template,
	provider: "ps"
}